<div class="card w-full h-full flex flex-col shadow-sm p-8 rounded-2xl bg-white gap-8">
  <div class="flex flex-row justify-between">
    <div class="flex flex-col">
      <h1 class="font-semibold text-2xl">
        Usuarios Externos
      </h1>
    </div>
    <div class="flex flex-col">
      <button class="rounded-3xl flex items-center gap-3 bg-orange-500 text-white py-4 px-8 cursor-pointer"
        (click)="openEditModal(null)">
        <span class="text-base">Crear nuevo usuario externo</span>
        <i class="fi-rr-add text-2xl flex"></i>
      </button>
    </div>
  </div>
  <div class="flex flex-row flex-wrap justify-start gap-4">
    <app-custom-input [(value)]="user" placeholder="Buscar usuarios..."
      (enter)="onPageChange({ page: 0, first: 0, rows: 10 })">
    </app-custom-input>
    <div class=" cursor-pointer">
      <select [(ngModel)]="status" id="country" name="country"
        class="cursor-pointer block  w-full border-gray-400  rounded-sm  pt-2 pb-2 pr-3 pl-3  bg-secondary-50 hover:bg-secondary-75/50 text-gray-800 placeholder-gray-400 px-4 py-2  focus:outline-none">
        <option [value]=null selected class="cursor-pointer">Todos</option>
        <option [value]=true class="cursor-pointer">Activos</option>
        <option [value]=false class="cursor-pointer">Inactivos</option>
      </select>
    </div>
    <app-button label="Buscar" (click)="onPageChange({ page: 0, first: 0, rows: 10 })"></app-button>
    <app-button label="Limpiar filtros" color="red-500" icon="fi-rr-eraser" (click)="cleanFilter()"></app-button>
  </div>
  <div class="overflow-x-auto">
    @if (compradorList && compradorList.length > 0) {
    <div class="card">
      <p-table [value]="compradorList" [paginator]="true" [rows]="rows" [first]="first" [lazy]="true"
        [lazyLoadOnInit]="false" (onLazyLoad)="loadBuyers($event)" [totalRecords]="totalItems" [sortField]="sortField" [sortOrder]="sortOrder"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas" [showCurrentPageReport]="true"
        [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template #header>
          <tr>
            <th pSortableColumn="id" class="px-4 py-2 text-left font-semibold text-base gap-2">ID <p-sortIcon
                field="id"></p-sortIcon></th>
            <th pSortableColumn="name" class="px-4 py-2 text-left font-semibold text-base gap-2">Nombre del Usuario
              <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="email" class="px-4 py-2 text-left font-semibold text-base gap-2">Correo <p-sortIcon
                field="email"></p-sortIcon></th>
            <th pSortableColumn="phone" class="px-4 py-2 text-left font-semibold text-base gap-2">Teléfono<p-sortIcon
                field="phone"></p-sortIcon></th>
            <th pSortableColumn="addressNumber" class="px-4 py-2 text-left font-semibold text-base gap-2">
              Nombre del cliente
              <p-sortIcon field="addressNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="warehouseCode" class="px-4 py-2 text-left font-semibold text-base gap-2">
              Bodega
              <p-sortIcon field="warehouseCode"></p-sortIcon>
            </th>
            <th pSortableColumn="active" class="px-4 py-2 text-left font-semibold text-base gap-2">Activo <p-sortIcon
                field="active"></p-sortIcon>
            </th>
            <th pSortableColumn="role" class="px-4 py-2 text-left font-semibold text-base gap-2">
              Rol
              <p-sortIcon field="role"></p-sortIcon>
            </th>
            <th class="px-4 py-2 text-left font-semibold text-base gap-2">Acción</th>
          </tr>
        </ng-template>
        <ng-template #body let-compradorList>
          <tr class="hover:bg-orange-50  ">
            <td class="px-6 py-4">{{ compradorList.id }}</td>
            <td class="px-6 py-4">{{ compradorList.name }}</td>
            <td class="px-6 py-4">{{ compradorList.email }}</td>
            <td class="px-6 py-4">{{ compradorList.phone }}</td>
            <td class="px-6 py-4">{{ getCustomerName(compradorList) }}</td>
            <td class="px-6 py-4">
              <div class="flex flex-wrap gap-2">
                @for (code of compradorList.warehouseCodes; track code) {
                  <span class="inline-flex px-3 py-1 text-xs font-medium rounded-xl bg-purple-100">
                    {{ code }}
                  </span>
                }
              </div>
            </td>
            <td class="px-6 py-4">
              <span class="inline-flex px-3 py-1 text-xs font-medium rounded-xl"
                [ngClass]="getBackgroundClasses(compradorList.active)">
                {{ compradorList.active }}
              </span>
            </td>
            <td class="px-6 py-4">
              <div class="flex flex-wrap gap-2">
                @for (roles of compradorList.roles; track roles.code) {
                  <span class="inline-flex px-3 py-1 text-xs font-medium rounded-xl"
                        [ngClass]="getBackgroundRoles(roles.code)">
                    {{ roles.code }}
                  </span>
                }
              </div>
            </td>
            <td class="px-6 py-4">
             <div class="text-gray-400 flex flex-row gap-1">
                <i class="fi fi-rr-pencil flex text-2xl text-blue-300 cursor-pointer hover:text-blue-700"
                  title="Editar" (click)="openEditModal(compradorList.id)"></i>
                  
                @if (compradorList.active) {
                <i class="fi fi-rr-toggle-on flex text-2xl text-green-500 cursor-pointer hover:text-green-700"
                  title="Desactivar" 
                  (click)="openDeleteModal(compradorList.name, compradorList.id, compradorList.active)"></i>
                } @else {
                <i class="fi fi-rr-toggle-off flex text-2xl text-gray-400 cursor-pointer hover:text-gray-600"
                  title="Activar" 
                  (click)="openDeleteModal(compradorList.name, compradorList.id, compradorList.active)"></i>
                }
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    } @else {
    <div class="bg-yellow-100 p-4 rounded-2xl">
      No hay registros
    </div>
    }

  </div>
</div>